import React, { Component } from "react";
import { Modal, Label, Icon, Button, Table, Checkbox } from "semantic-ui-react";
import { connect } from "react-redux";
import { notify } from "react-notify-toast";
import swal from "sweetalert2";
import { laravelService } from "../../utils/laravelService";
import Config from "../../config/index";

export class CheckModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedMaterials: [],
      selectedContacts: [],
      loading: false,
    };
  }

  updateRequestedQuantity = (id, quantity) => {
    const exists = this.state.selectedMaterials.find((item) => item.id === id);
    if (exists) {
      this.setState({
        selectedMaterials: this.state.selectedMaterials.map((item) =>
          item.id === id ? { ...item, requested_quantity: quantity } : item
        ),
      });
    } else {
      this.setState({
        selectedMaterials: [
          ...this.state.selectedMaterials,
          { id, requested_quantity: quantity },
        ],
      });
    }
  };

  toggleSelectedMaterial = (id) => {
    const exists = this.state.selectedMaterials.find((item) => item.id === id);
    if (exists) {
      this.setState({
        selectedMaterials: this.state.selectedMaterials.filter(
          (item) => item.id !== id
        ),
      });
    } else {
      this.setState({
        selectedMaterials: [
          ...this.state.selectedMaterials,
          { id, requested_quantity: 1 },
        ],
      });
    }
  };

  postRawMaterialEmail = async (emailData) => {
    this.setState(
      {
        loading: true,
      },
      async () => {
        await laravelService
          .post(`inventory/rawMaterialProviderEmail`, emailData)
          .then(() => {
            notify.show("Correo electrónico enviado", "success");
            this.props.onClose();
          })
          .catch((error) => {
            console.log("error", error);
            notify.show("Error al enviar correo electrónico", "error");
          })
          .finally(() => {
            this.setState({
              loading: false,
            });
          });
      }
    );
  };

  render() {
    console.log("this.props", this.props);
    return (
      <Modal open={this.props.isOpened} size={"small"}>
        <Modal.Header style={{ backgroundColor: "#f3f3f3" }}>
          Proveedor: {this.props.data.proveedor} {this.props.data.id}
          <Button
            circular
            size="mini"
            basic
            icon="close"
            floated="right"
            onClick={this.props.onClose}
          />
        </Modal.Header>
        <Modal.Content>
          <p style={{ fontSize: 18 }}>
            Seleccione las materias primas a solicitar en el correo electrónico.
          </p>
          <div>
            {this.props.data.materias_primas ? (
              this.props.data.materias_primas.length !== 0 && (
                <Table compact>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell></Table.HeaderCell>
                      <Table.HeaderCell>Materia Prima</Table.HeaderCell>
                      <Table.HeaderCell>MIN.</Table.HeaderCell>
                      <Table.HeaderCell>MAX.</Table.HeaderCell>
                      <Table.HeaderCell>Cantidad</Table.HeaderCell>
                      <Table.HeaderCell>¿Abajo del mínimo?</Table.HeaderCell>
                      <Table.HeaderCell>Cantidad a Solicitar</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {this.props.data.materias_primas.map((rm, i) => {
                      const selectedItem = this.state.selectedMaterials.find(
                        (item) => item.id === rm.materia_prima_id
                      );
                      const quantity = selectedItem
                        ? selectedItem.requested_quantity
                        : 1;

                      return (
                        <Table.Row key={i}>
                          <Table.Cell>
                            <Checkbox
                              checked={!!selectedItem}
                              onChange={() =>
                                this.toggleSelectedMaterial(rm.materia_prima_id)
                              }
                            />
                          </Table.Cell>
                          <Table.Cell>{rm.nombre || "N/A"}</Table.Cell>
                          <Table.Cell>{rm.min || "N/A"}</Table.Cell>
                          <Table.Cell>{rm.max || "N/A"}</Table.Cell>
                          <Table.Cell>{rm.cantidad || "N/A"}</Table.Cell>
                          <Table.Cell>
                            {rm.is_below_min ? "Si" : "No"}
                          </Table.Cell>
                          <Table.Cell>
                            {selectedItem ? (
                              <input
                                type="number"
                                min={1}
                                step={1}
                                style={{ width: "60px" }}
                                value={quantity}
                                onChange={(e) =>
                                  this.updateRequestedQuantity(
                                    rm.materia_prima_id,
                                    parseInt(e.target.value, 10) || 1
                                  )
                                }
                              />
                            ) : (
                              <input
                                type="number"
                                min={0}
                                disabled={true}
                                step={1}
                                style={{ width: "60px" }}
                                value={0}
                                onChange={(e) => {}}
                              />
                            )}
                          </Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              )
            ) : (
              <></>
            )}
            <p style={{ fontSize: 18 }}>
              Seleccione a los contactos a quienes se les enviará el correo
              electrónico.
            </p>
            {this.props.data.contactos ? (
              this.props.data.contactos.length !== 0 && (
                <Table compact>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell></Table.HeaderCell>
                      <Table.HeaderCell>Contacto</Table.HeaderCell>
                      <Table.HeaderCell>Correo</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {this.props.data.contactos.map((contacto, i) => {
                      return (
                        <Table.Row key={i}>
                          <Table.Cell>
                            <Checkbox
                              checked={this.state.selectedContacts.includes(
                                contacto.id
                              )}
                              onChange={(e, data) => {
                                if (
                                  !this.state.selectedContacts.includes(
                                    contacto.id
                                  )
                                ) {
                                  const newSelectedContacts = [
                                    ...this.state.selectedContacts,
                                    contacto.id,
                                  ];
                                  this.setState({
                                    selectedContacts: newSelectedContacts,
                                  });
                                } else {
                                  const newSelectedContacts = this.state.selectedContacts.filter(
                                    (ctc) => ctc !== contacto.id
                                  );
                                  this.setState({
                                    selectedContacts: newSelectedContacts,
                                  });
                                }
                              }}
                            />
                          </Table.Cell>
                          <Table.Cell>{contacto.nombre || "N/A"}</Table.Cell>
                          <Table.Cell>{contacto.email || "N/A"}</Table.Cell>
                        </Table.Row>
                      );
                    })}
                  </Table.Body>
                </Table>
              )
            ) : (
              <></>
            )}
            <div>
              <Button
                fluid
                disabled={!this.state.selectedMaterials.length}
                color="green"
                icon="send outline"
                loading={this.state.loading}
                onClick={async () => {
                  const selectedRawMaterials = this.state.selectedMaterials.map(
                    (selected) => {
                      const rawMaterial = this.props.data.materias_primas.find(
                        (rm) => rm.materia_prima_id === selected.id
                      );

                      return {
                        ...rawMaterial,
                        requested_quantity: selected.requested_quantity,
                      };
                    }
                  );

                  const selectedContactsMap = this.props.data.contactos.filter(
                    (ctc) => this.state.selectedContacts.includes(ctc.id)
                  );

                  const selectedContactsEmails = selectedContactsMap.map(
                    (ctc) => ctc.email
                  );

                  await swal({
                    title: "¿Desea enviar un correo al proveedor?",
                    type: "warning",
                    confirmButtonText: "OK",
                    showCancelButton: true,
                    reverseButtons: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Enviar",
                    cancelButtonText: "Cancelar",
                  }).then(async (result) => {
                    if (result.value) {
                      const mailData = {
                        providerEmail: selectedContactsEmails,
                        userEmail: this.props.user.email, // uncomment on prod
                        // userEmail: "mzamarron@acsyt.com",
                        rawMaterials: selectedRawMaterials,
                      };

                      await this.postRawMaterialEmail(mailData);
                    }
                  });
                }}
              >
                Enivar correo electrónico
              </Button>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(CheckModal);
